var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'notificacao-userbar-novo': this.config.USERBAR_NOVO },attrs:{"id":"topNotifications"}},[_c('span',{staticClass:"notification-icon cursor-pointer",on:{"click":_vm.openNotificationModal}},[_c('i',{staticClass:"fas fa-bell"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }